import { apiHelper } from '@/utils'
import { API } from '@/constants'

export const roleService = {
    getAllRoles,
    getRole,
    updateRole,
    createRole,
    updateRoleStatus 
};

const MODULE = {
  ROLE: 'roles',
}

// const API_URL = API.BASE_URL.replace('@serviceName', 'user') + '/v1'
const API_URL = API.BASE_URL + '/v1'


export function getAllRoles(filter) {
    const requestOptions = {
      params: {
        page: filter.pageNumber,
        size: filter.pageSize,
        is_locked: filter.isLocked,
        is_active: filter.isActive, 
        name: filter.roleName
      }
    }
  
    return apiHelper(API_URL).get(`/${MODULE.ROLE}`, requestOptions)
  }

  export function getRole(id) {
    return apiHelper(API_URL).get(`/${MODULE.ROLE}/${id}`)
  }

  export function updateRole(data) {
    const requestOptions = {
      is_active: data.isActive,
      permission_codes: data.permissions
    }
  
    return apiHelper(API_URL).put(`/${MODULE.ROLE}/${data.id}`, requestOptions)
  }

  export function createRole(data) {
    const requestOptions = {
      name: data.name,
      permission_codes: data.permissions
    }
  
    return apiHelper(API_URL).post(`/${MODULE.ROLE}`, requestOptions)
  }

  export function updateRoleStatus(data) {
    const requestOptions = {
      is_active: data.isActive
    }
  
    return apiHelper(API_URL).patch(`/${MODULE.ROLE}/${data.id}`, requestOptions)
  }